import React, { useState } from "react";
import '../../sass/components/flexibleModules/_components.imageGridsExecutiveTeams.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import iconTwitter from '../../images/icon-twitter.svg';
import iconLinkedin from '../../images/icon-linkedin.svg';
import iconClose from '../../images/icon-close.svg';

const ImageGridsExecutiveTeams = ({ data }) => {

    const [modalShow, setmodalShow] = useState(false);
    const [modalShowIndex, setmodalShowIndex] = useState(null);
    const showModal = (val, valindex) => {
        setmodalShow(val);
        setmodalShowIndex(valindex);
    }

    return (
        <div className="cp-imageGridsExecutiveTeams" style={{ backgroundColor: `${data.backgroundColor ? data.backgroundColor : ""}` }}>
            <div className="cp-imageGridsExecutiveTeams__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.imageGridsExecutiveTeamsHeader &&
                    <h2>{data.imageGridsExecutiveTeamsHeader}</h2>
                }
                {data.imageGridsExecutiveTeamsMembersRepeater &&
                    <div className="cp-members l--flex">
                        {data.imageGridsExecutiveTeamsMembersRepeater.map((member, index) => (
                            <button onClick={() => showModal(true, index)} className="cp-members__section l--flex" key={index}>
                                {member.memberThumb &&
                                    <GatsbyImage image={getImage(member.memberThumb.gatsbyImage)} alt={member.memberThumb.altText} />
                                }
                                <span>
                                    {member.memberName &&
                                        <span className="cp-members__section-name">{member.memberName}</span>
                                    }
                                    {member.memberTitle &&
                                        <span className="cp-members__section-title">{member.memberTitle}</span>
                                    }
                                </span>
                            </button>
                        ))}
                    </div>
                }

                {modalShow &&
                    <div className="cp-modal">
                        {data.imageGridsExecutiveTeamsMembersRepeater.map((member, index) => (
                            <>
                                {index === modalShowIndex &&
                                    <div className="cp-modalMember l--flex" key={index}>
                                        <div className="cp-modalMember__left">
                                            {member.memberThumb &&
                                                <GatsbyImage image={member.memberThumb.gatsbyImage} alt={member.memberThumb.altText} />
                                            }
                                        </div>
                                        <div className="cp-modalMember__right">
                                            <div className="cp-modalMember__right-top l--flex">
                                                <div>
                                                    {member.memberName &&
                                                        <span className="cp-members__section-name">{member.memberName}</span>
                                                    }
                                                    {member.memberTitle &&
                                                        <span className="cp-members__section-title">{member.memberTitle}</span>
                                                    }
                                                </div>
                                                <div className="l--flex">
                                                    {member.memberTwitterLink &&
                                                        <a href={member.memberTwitterLink} target="_blank">
                                                            <img loading="lazy" src={iconTwitter} alt="" />
                                                        </a>
                                                    }
                                                    {member.memberLinkedinLink &&
                                                        <a href={member.memberLinkedinLink} target="_blank">
                                                            <img loading="lazy" src={iconLinkedin} alt="" />
                                                        </a>
                                                    }
                                                </div>
                                            </div>
                                            <div className="cp-modalMember__right-bottom">
                                                {member.memberBio &&
                                                    <div dangerouslySetInnerHTML={{ __html: member.memberBio }} />
                                                }
                                            </div>
                                        </div>
                                        <button className="cp-modal__close" onClick={() => showModal(false, -1)}>
                                            <img src={iconClose} alt="" />
                                        </button>
                                    </div>
                                }
                            </>
                        ))}
                        <button className="cp-modal__backgroundTrigger" onClick={() => showModal(false, -1)}></button>
                    </div>
                }

            </div>
        </div>
    );
}

export default ImageGridsExecutiveTeams;